import PubSub from "pubsub-js"
import { initialiseComponents } from "../core"
import { hw } from "./helpers/paths"

export type ConcreteComponentConstructor = new (
    ...args: ConstructorParameters<typeof Component>
) => Component

/**
 * Main Class for all Components
 */
export default abstract class Component {
    constructor(props: unknown, protected element: HTMLElement) {
        PubSub.subscribe("mounted", () => this.mounted())
    }

    abstract mounted(): void

    getElement(): HTMLElement {
        return this.element
    }

    nextSibling(): ChildNode {
        return this.element.nextElementSibling;
    }

    previousSibling(): ChildNode {
        return this.element.previousElementSibling;
    }

    protected injectTemplate({initializeComponentAfterInject = true } = {}): void {
        let async
        const request = new XMLHttpRequest()
        request.open(
            "GET",
            hw.getBaseRessourcesUrl() + "/templates/" + this.constructor.name + ".html",
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            (async = false)
        )
        request.send(null)
        if (request.status === 200) {
            this.element.insertAdjacentHTML("beforeend", request.responseText)
        }
        if(initializeComponentAfterInject) {
            initialiseComponents()
        }
    }

    /**
     * Render the content of a`<template>`tag present in the DOM. 
     * - The id in the template must have the name of the javascript component / constructor name. 
     * - Reason : Needed to be able to use tailwind css on the injected html.
     * @param initializeComponentAfterInject
     */
    protected injectTemplateFromDOM({ initializeComponentAfterInject = true } = {}): void {
        const template = document.getElementById(this.constructor.name)
        this.element.insertAdjacentHTML("beforeend", template.innerHTML)
        if (initializeComponentAfterInject) {
            initialiseComponents()
        }
    }
}
